import 'primeicons/primeicons.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.css';
import './Assets/Styles/main.scss';

import React, {ReactElement} from 'react';
import {ToastContainer} from "react-toastify";
import Router from "./Pages/Router";

const App = (): ReactElement => {
    return (
        <>
            <Router/>
            <ToastContainer autoClose={3000}/>
        </>
    );
}

export default App;
